export default {
    softwareProductElements: [{required: true, message: 'Please input Product Elements!'}],
    softwareProduct: [{required: true, message: 'Please input Software Product!'}],
    code: [{required: true, message: 'Please input Code!'}],
    expiryLicenceActionId: [{required: true, message: 'Please input Expiry Licence!'}],
    expiryDate: [{required: true, message: 'Please input Expiry Date!'}],
    quantity: [{required: true, message: 'Please input Quantity!'}],
    company: [{required: true, message: 'Please input Company!'}],
};